<template>
  <v-dialog hide-overlay max-width="800px" v-model="show">
    <v-card>
      <v-card-title>品番詳細</v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_SKU_NEW>{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="cancel">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form v-model="valid">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md6 sm6 xs12>
                <div required>
                  <v-text-field
                    :rules="[(v) => !!v || '品番CD is required']"
                    clearable
                    label="品番CD"
                    v-model="form.code"
                  />
                </div>
                <v-text-field
                  clearable
                  label="品番（海外)CD"
                  v-model="form.supplierCode"
                />
                <v-text-field
                  clearable
                  label="部品名称１"
                  v-model="form.name"
                />
                <v-text-field
                  clearable
                  label="部品名称2"
                  v-model="form.name2"
                />
                <remote-autocomplete
                  :label="$t('app.labels.partner')"
                  url="companies/kv?type=PARTNER"
                  v-model="form.partnerId"
                />
                <div required>
                  <remote-autocomplete
                    :label="$t('app.labels.productCode')"
                    :rules="[(v) => !!v || '品種 is required']"
                    item-text="name"
                    item-value="code"
                    url="products/codes"
                    v-model="form.productCode"
                  />
                </div>
                <v-text-field
                  clearable
                  label="部品区分名"
                  v-model="form.type"
                />
              </v-flex>
              <v-flex md6 sm6 xs12>
                <remote-autocomplete
                  label="単価外貨"
                  url="currencies/kv"
                  v-model="form.unitPriceCurrencyCode"
                />
                <div required>
                  <v-text-field
                    :rules="[(v) => !!v || '単価 is required']"
                    clearable
                    label="単価"
                    type="number"
                    v-model="form.unitPrice"
                  />
                </div>
                <v-text-field
                  clearable
                  label="N/W重量単位"
                  type="number"
                  v-model="form.netWeightUnit"
                />
                <v-text-field
                  clearable
                  label="1個当りのN/W"
                  type="number"
                  v-model="form.unitNetWeight"
                />
                <v-text-field
                  clearable
                  label="箱重量単位"
                  type="number"
                  v-model="form.boxWeightUnit"
                />
                <v-text-field
                  clearable
                  label="箱の重さ"
                  type="number"
                  v-model="form.boxWeight"
                />
                <v-text-field
                  clearable
                  label="入り数"
                  type="number"
                  v-model="form.boxQty"
                />
                <v-text-field
                  clearable
                  label="箱サイズ縦"
                  type="number"
                  v-model="form.boxWidth"
                />
                <v-text-field
                  clearable
                  label="箱サイズ横"
                  type="number"
                  v-model="form.boxLength"
                />
                <v-text-field
                  clearable
                  label="箱サイズ高さ"
                  type="number"
                  v-model="form.boxHeight"
                />
                <v-text-field
                  clearable
                  label="容積単位"
                  type="number"
                  v-model="form.boxVolumeUnit"
                />
                <v-text-field
                  clearable
                  label="箱容積"
                  type="number"
                  v-model="form.boxVolume"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      form: { type: '完成品' },
      valid: null,
      show: false,
      resolve: null,
      reject: null,
    }
  },
  methods: {
    save() {
      if (this.valid) {
        this.$http
          .put(`skus`, this.form)
          // .then(() => {
          //   return this.$http.post('/purchase-orders/po-sku', this.form)
          // })
          .then((res) => {
            this.show = false
            this.resolve(res)
          })
          .catch((err) => {
            this.$message('', 'ERROR')
          })
      }
    },
    popup(item) {
      this.show = true
      this.form.code = item.innerSatCode
      this.form.name = item.innerSatName
      this.form.supplierCode = item.outerSatCode
      this.form.name2 = item.outerSatName
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    cancel() {
      this.show = false
    },
  },
}
</script>
